import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../../core/_BLComponent.jsx';
import Slider 				from 'react-slick';

import FirstSlide			from './slides/_FirstSlide.jsx';
import SecondSlide			from './slides/_SecondSlide.jsx';
import ThirdSlide			from './slides/_ThirdSlide.jsx';
import FourthSlide			from './slides/_FourthSlide.jsx';
import FifthSlide			from './slides/_FifthSlide.jsx';


export default class FTUXModalBody extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state = {
			activeStory: 0,
			nStories: 0
			
		}

		this.slickSettings = {
			dots: true,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			swipeToSlide: true,
			dotsClass: "slick-dots l-center-v",
			beforeChange:(oldIndex, newIndex)=>this.changeSlide(oldIndex, newIndex)
		}
	}

	componentDidMount() 
	{
		$(".slick-list").css("height", "auto !important");
	}

	componentWillUnmount() 
	{
		this.setState = (state,callback)=>{
        	return;
    	};
	}


	render()
	{
		return (
			<div>
				<Slider className="personal-inventory__ftux-slider slick-slider--adaptive" ref={slider => this.slider = slider} {...this.slickSettings}>
					<FirstSlide func={{slidePrev:()=>this.slidePrev(), slideNext:()=>this.slideNext()}}/>
					<SecondSlide func={{slidePrev:()=>this.slidePrev(), slideNext:()=>this.slideNext()}}/>
					<ThirdSlide func={{slidePrev:()=>this.slidePrev(), slideNext:()=>this.slideNext()}}/>
					<FourthSlide func={{slidePrev:()=>this.slidePrev(), slideNext:()=>this.slideNext()}}/>
					<FifthSlide func={{slidePrev:()=>this.slidePrev(), slideNext:()=>this.slideNext()}}/>
					
				</Slider>
				<div className="l-margin-top--xl text--center l-margin-bottom--xl">
					{(this.state.activeStory == 0)&&			
						<button id="MPI-skipTour-btn-tour" className="btn l-margin-right" onClick={()=>this.props.func.toggleModal()}>Skip tour</button>
					}
					
					{(this.state.activeStory > 0) && (this.state.activeStory <= 4) &&			
						<button id="MPI-previous-btn-tour" className="btn l-margin-right" onClick={()=>this.slidePrev()}>Previous</button>
					}

					{(this.state.activeStory < 4)&&
						<button id="MPI-next-btn-tour" className="btn btn--cta" onClick={()=>this.slideNext()}>Next</button>
					}
					{(this.state.activeStory == 4)&&
						<button id="MPI-letsGo-btn-tour" className="btn btn--cta" onClick={()=>this.props.func.toggleModal()}>Let's go</button>
					}
				</div>
			</div>
		)
	}

	slidePrev() {
		this.slider.slickPrev();
	}

	slideNext() {
		this.slider.slickNext();
	}

	changeSlide(oldIndex, newIndex) {

		this.setState({activeStory: newIndex});
	}

};

